import React, { useState, useEffect } from 'react';
import TagList from './TagList';

export default function TagFinder({ num }) {
    const maxTagBarLength = 24;
    const [maxTagNumber, setMaxTagNumber] = useState(0);
    const tagList = TagList();

    useEffect(() => {
        let thisTagListLength = 0;
        for (let i = 0; i < num.length; i++) {
            thisTagListLength += tagList[num[i]].length;
            if (thisTagListLength > maxTagBarLength) {
                setMaxTagNumber(i);
                return;
            }
        }
        setMaxTagNumber(num.length); // If all tags fit
    }, [num, tagList]);

    return (
        <div className="section-unit-tags-container">
            {num.slice(0, maxTagNumber).map((tag, index) => (
                <div
                    key={index}
                    className={"section-unit-tag section-unit-tag-" + tagList[tag].name}
                    style={{ backgroundColor: tagList[tag].color }}
                >
                    {tagList[tag].name}
                </div>
            ))}
            {num.length - maxTagNumber > 0 && (
                <div className="section-unit-tag section-unit-tag-extra">
                    {num.length - maxTagNumber}+
                </div>
            )}
        </div>
    );
}
